import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PrettyJsonPipe } from '../../pipes';

@Component({
  selector: 'core-pretty-json',
  imports: [PrettyJsonPipe],
  templateUrl: './pretty-json.component.html',
  styleUrl: './pretty-json.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrettyJsonComponent {
  value = input<string>();
  showNumberLine = input<boolean>(false);
  padding = input<number>(3);
}
